import { useTranslation } from 'react-i18next';
import { Head } from '~/components/shared/Head';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Tags from './components/Tags';
import Users from './components/Users';
import UserDetail from './components/UserDetail';
import { TeamNavigation } from './components/TeamNavigation';
import ActionBar from './components/ActionBar';
import ProfileAttributes from './components/ProfileAttributes';

const TeamManagement = () => {
  const [t] = useTranslation('teams');
  const location = useLocation();

  const getTitleKey = (pathname: string) => {
    if (pathname.includes('users')) return 'title_users';
    if (pathname.includes('tags')) return 'title_tags';
  if (pathname.includes('profile')) return 'title_profile_settings';
    return 'teams.defaultTitle';
  };

  const titleKey = getTitleKey(location.pathname);
  const [searchValue, setSearchValue] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');
  const [selectedSort, setSelectedSort] = useState('');
  const [isAddClicked, setIsAddClicked] = useState(false);

  const handleAddClick = () => {
    setIsAddClicked(true);
  };

  useEffect(() => {
    setSearchValue('');
    setSelectedFilter('');
    setSelectedSort('');
    setIsAddClicked(false);
  }, [location.pathname]);

  return (
    <div className="m-auto w-full max-w-[1200px] px-8 pt-12">
      <Head title={t('title_teams')} />
      <h1 className="text-2xl font-medium">{t('title_teams')}</h1>
      <TeamNavigation />

      {/* Action Bar - only show when we're in a specific section */}
      {(location.pathname.includes('users') ||
        location.pathname.includes('tags') ||
        location.pathname.includes('profile')) && (
        <div className="sticky top-0 z-10 mb-4 w-full items-center gap-4 bg-white">
          <ActionBar
            onSearchChange={setSearchValue}
            onFilterChange={setSelectedFilter}
            onSortChange={setSelectedSort}
            titleKey={titleKey}
            onAddClick={handleAddClick}
            searchValue={searchValue}
          />
        </div>
      )}

      <div className="mb-24 h-[70vh] w-full overflow-y-scroll rounded-2xl bg-base-100 p-6 lg:mb-0">
        <Routes>
          {/* Default route - redirect to users */}
          <Route index element={<Navigate to="users" replace />} />

          <Route
            path="users/*"
            element={
              <Users
                searchValue={searchValue}
                selectedFilter={selectedFilter}
                selectedSort={selectedSort}
                isAddClicked={isAddClicked}
                setIsAddClicked={setIsAddClicked}
              />
            }
          />
          <Route
            path="tags/*"
            element={
              <Tags
                searchValue={searchValue}
                selectedFilter={selectedFilter}
                selectedSort={selectedSort}
                isAddClicked={isAddClicked}
                setIsAddClicked={setIsAddClicked}
              />
            }
          />
          <Route
            path="profile/*"
            element={
              <ProfileAttributes
                searchValue={searchValue}
                selectedFilter={selectedFilter}
                selectedSort={selectedSort}
                isAddClicked={isAddClicked}
                setIsAddClicked={setIsAddClicked}
              />
            }
          />
          <Route path="users/:idUser" element={<UserDetail />} />
        </Routes>
      </div>
    </div>
  );
};

export default TeamManagement;
